import { useState } from 'react';

export function useAirtable() {
  const [status, setStatus] = useState('idle');
  const [error,  setError]  = useState(null);

  const token     = process.env.REACT_APP_AIRTABLE_TOKEN;
  const baseId    = process.env.REACT_APP_AIRTABLE_BASE_ID;
  const tableName = process.env.REACT_APP_AIRTABLE_TABLE_NAME || 'Contacts';

  async function submit({ firstName, lastName, email, phone, interest, message }) {
    setStatus('loading');
    setError(null);

    if (!token || !baseId || token.startsWith('patXXX')) {
      setStatus('error');
      setError('Airtable is not configured yet. Copy .env.example to .env and add your credentials.');
      return false;
    }

    const url = `https://api.airtable.com/v0/${baseId}/${encodeURIComponent(tableName)}`;

    const body = {
      fields: {
        'First Name':   firstName,
        'Last Name':    lastName,
        'Email':        email,
        'Phone':        phone || '',
        'Interest':     interest || '',
        'Message':      message,
        'Submitted At': new Date().toISOString(),
        'Source':       'Website Contact Form',
      },
    };

    try {
      const res = await fetch(url, {
        method:  'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err?.error?.message || `HTTP ${res.status}`);
      }

      setStatus('success');
      return true;
    } catch (err) {
      console.error('[Airtable]', err);
      setError(err.message || 'Something went wrong. Please try again.');
      setStatus('error');
      return false;
    }
  }

  function reset() { setStatus('idle'); setError(null); }

  return { submit, status, error, reset };
}
